import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { InvitationCodesPage } from '@/features/invitation-code/list-page';

export const Route = createFileRoute(
  '/_authenticated/operations/invitation-codes',
)({
  beforeLoad: ({ context, location }) =>
    requirePermission(
      context.queryClient,
      location.href,
      'invitationCodes:read',
    ),
  component: InvitationCodesPage,
});
